import { render } from "./ChangeEmail.vue.js?vue&type=template&id=0bef770b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeEmail.vue?vue&type=template&id=0bef770b"
import script from "./ChangeEmail.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeEmail.vue?vue&type=script&lang=js"
export * from "./ChangeEmail.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-settings-page/ChangeEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bef770b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bef770b', __exports__)) {
    api.reload('0bef770b', __exports__)
  }
  
  module.hot.accept("./ChangeEmail.vue.js?vue&type=template&id=0bef770b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeEmail.vue?vue&type=template&id=0bef770b", () => {
    api.rerender('0bef770b', render)
  })

}


export default __exports__